import type { I18nFn } from '#/i18n/types/I18nFn';
import type { SearchFacetData } from '#/modules/search/types/SearchFacetData';
import { ORG_TYPES } from '#/utils/constants/general/orgTypes';

export function orgTypeFacet(i18n: I18nFn) {
  return {
    id: 'orgTypeFacet',
    name: 'orgType',
    get title() {
      return i18n('Org Type');
    },
    type: 'array',
    options: Object.keys(ORG_TYPES(i18n)),
    optionTitles: ORG_TYPES(i18n),
    sort: false,
  } as const satisfies SearchFacetData;
}
